<template>
  <v-container>
    <v-dialog   v-model="submitDialog" width="500">
      <v-card>
        <v-card-title  dark class="headline green white--text" >
          Thank You! Your feedback has been submitted.
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" dark @click="submitDialog = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card>
      <v-toolbar color="blue darken-3" dark>
        <v-toolbar-title>Reach out to us!</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <v-btn color=" blue darken-3" @click="feedback()" depressed>
                <v-icon class= "pr-2" >send</v-icon > Send
            </v-btn>-->
        <v-btn color=" blue darken-3" @click="feedback()" depressed>
          <v-icon class="pr-2">mdi-send</v-icon> Send
        </v-btn>
      </v-toolbar>
      <v-form class="pa-5" ref="form">
        <v-text-field
          label="Subject"
          single-line
          full-width
          :rules="subjectRules"
          :counter="256"
          v-model="subject"
        ></v-text-field>
        <v-divider></v-divider>
        <v-textarea
          v-model="message"
          label="Message"
          :rules="messageRules"
          :counter="1000"
          full-width
          single-line
        ></v-textarea>
        <v-layout row fill-height justify-center align-center v-if="isSending">
          <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
          ></v-progress-circular>
        </v-layout>
      </v-form>
    </v-card>
    <v-snackbar v-model="isError" top left  class="red--text">
      Sorry there has been an error! Please try again later.
    </v-snackbar>
  </v-container>
</template>

<script>
import { router } from "../router";
import { siteService } from "../services";
import { checkLogin } from '../helpers/check'

export default {
  data() {
    return {
      isSending: false,
      isSent: false,
      isError: false,
      message: "",
      subject: "",
      submitDialog: false,
      subjectRules: [
          v => !!v || "The subject is required",
          v =>
              (v && v.length <= 256) ||
              "The subject must be less than 256 characters"
      ],
      messageRules: [
          v => !!v || "The message is required",
          v =>
              (v && v.length <= 1000) ||
              "The message must be less than 1000 characters"
      ],
    };
  },
  computed: {
      alert () {
          return this.$store.state.alert
      }
  },
  mounted: function() {
    this.checkLoggedIn();
  },
  methods: {
    checkLoggedIn() {
      if (checkLogin()) {
        router.push("/login");
      }
    },
    feedback() {
      if (this.$refs.form.validate()) {
          this.isSending = true;
          const data = {
              subject: this.subject,
              message: this.message,
          };
          siteService.userMail(data).then(
              response => {
                  this.isSending = false;
                  this.isSent = true;
                  this.submitDialog = true;
                  this.$refs.form.reset();
              },
              error => {
                  this.isError = true;
                  this.isSent = false;
                  this.isSending = false;
                  this.verified = false;
              }
          );
      }
    }
  }
};
</script>
